<template>
  <Badges
    v-if="normalizedFilter.length"
  >
    <Badges
      v-for="(item, i) in normalizedFilter"
      :key="i"
      class="active-filter"
    >
      <Badge
        status="primary"
        class="active-value"
      >
        <strong>{{ title }}:</strong>
        {{ item }}
      </Badge>
      <!--
      <Badge
        class="active-icon"
        status="primary"
        icon-only="fas fa-times"
        @click="removeFilter(item)"
      /> -->
    </Badges>
  </Badges>
</template>

<script setup>
import { computed } from 'vue';
import { Badge, Badges } from '@stakeui';
import { prettifyMixedCase } from '@frontend/shared/Util.js';
import { useTaskStore } from '@frontend/ui/stores/taskStore.js';

const taskStore = useTaskStore();

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  filter: {
    type: [Array, Boolean, String],
    required: true,
  },
});

const removeFilter = value => {
  taskStore.removeFilterValue('tasks', props.id, value);
};

const normalizedFilter = computed(() => {
  const value = props.filter;

  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed ? [trimmed] : [];
  }

  if (Array.isArray(value)) {
    return value.map(v => {
      if (typeof v === 'object' && v !== null) {
        return v.name ?? v.id ?? '';
      }
      return v;
    }).filter(Boolean);
  }

  if (typeof value === 'object' && value !== null) {
    return value.name ? [value.name] : [];
  }

  if (typeof value === 'boolean') {
    return value ? ['Yes'] : [];
  }

  return [];
});

const title = computed(() => prettifyMixedCase(props.id));
</script>

<style scoped>
.active-filter {
  display: flex;
  align-items: center;
  gap: 1px;
  flex-wrap: wrap;
}

.active-title {
  /* border-top-right-radius: 0; */
  /* border-bottom-right-radius: 0; */
}

.active-value {
  /* border-top-right-radius: 0; */
  /* border-bottom-right-radius: 0; */
  text-transform: capitalize;
}

.active-icon {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>
